// @generated by TypeGen from LogbookApi/CurrentLogApi - DO NOT EDIT

import type { ICancelProvisionalRequest, ICurrentDayResponse, IEngineStatusRequest, ILightingStatusRequest, ILogRequest, ISailChangeRequest, IStopRequest } from "../LogbookApp/CurrentLogApi"
import type { IEngineHintRequest } from "../LogbookApp/EngineMissingApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import type { ICurrentInfo } from "../LogbookModel/Current"
import type { ILogResponse } from "../LogbookModel/Log"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface CurrentLogApiEndpoints {
  "GET /api/ship/current": {
    params: {};
    query: {};
    request: never;
    response: ICurrentInfo;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ship/current/day": {
    params: {};
    query: {};
    request: never;
    response: ICurrentDayResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/engine": {
    params: {};
    query: {};
    request: IEngineStatusRequest;
    response: ILogResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/engineHint": {
    params: {};
    query: {};
    request: IEngineHintRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/lighting": {
    params: {};
    query: {};
    request: ILightingStatusRequest;
    response: ILogResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/log": {
    params: {};
    query: {};
    request: ILogRequest;
    response: ILogResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/provisional/cancel": {
    params: {};
    query: {};
    request: ICancelProvisionalRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/sails": {
    params: {};
    query: {};
    request: ISailChangeRequest;
    response: ILogResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/current/stop": {
    params: {};
    query: {};
    request: IStopRequest;
    response: ILogResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const currentLogApiEndpoints = {
  "GET /api/ship/current": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "GET /api/ship/current/day": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "POST /api/ship/current/engine": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/engineHint": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/lighting": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/log": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/provisional/cancel": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/sails": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "POST /api/ship/current/stop": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class CurrentLogApi {
  constructor(private client: ApiClient) {}

  current = {
    get: (a: ApiArgs<CurrentLogApiEndpoints, "GET /api/ship/current">) => ({
      call: (): Promise<ICurrentInfo> => {
        assertTarget(this.client, "GET /api/ship/current", currentLogApiEndpoints["GET /api/ship/current"].targets);
        return this.client.call<ICurrentInfo>("GET /api/ship/current", a);
      },
      url: (): string => this.client.url("GET /api/ship/current", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    day: (a: ApiArgs<CurrentLogApiEndpoints, "GET /api/ship/current/day">) => ({
      call: (): Promise<ICurrentDayResponse> => {
        assertTarget(this.client, "GET /api/ship/current/day", currentLogApiEndpoints["GET /api/ship/current/day"].targets);
        return this.client.call<ICurrentDayResponse>("GET /api/ship/current/day", a);
      },
      url: (): string => this.client.url("GET /api/ship/current/day", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    engine: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/engine">) => ({
      call: (): Promise<ILogResponse> => {
        assertTarget(this.client, "POST /api/ship/current/engine", currentLogApiEndpoints["POST /api/ship/current/engine"].targets);
        return this.client.call<ILogResponse>("POST /api/ship/current/engine", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/engine", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    engineHint: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/engineHint">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/current/engineHint", currentLogApiEndpoints["POST /api/ship/current/engineHint"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/current/engineHint", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/engineHint", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    lighting: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/lighting">) => ({
      call: (): Promise<ILogResponse> => {
        assertTarget(this.client, "POST /api/ship/current/lighting", currentLogApiEndpoints["POST /api/ship/current/lighting"].targets);
        return this.client.call<ILogResponse>("POST /api/ship/current/lighting", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/lighting", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    log: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/log">) => ({
      call: (): Promise<ILogResponse> => {
        assertTarget(this.client, "POST /api/ship/current/log", currentLogApiEndpoints["POST /api/ship/current/log"].targets);
        return this.client.call<ILogResponse>("POST /api/ship/current/log", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/log", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    cancelProvisional: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/provisional/cancel">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/current/provisional/cancel", currentLogApiEndpoints["POST /api/ship/current/provisional/cancel"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/current/provisional/cancel", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/provisional/cancel", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    sails: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/sails">) => ({
      call: (): Promise<ILogResponse> => {
        assertTarget(this.client, "POST /api/ship/current/sails", currentLogApiEndpoints["POST /api/ship/current/sails"].targets);
        return this.client.call<ILogResponse>("POST /api/ship/current/sails", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/sails", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    stop: (a: ApiArgs<CurrentLogApiEndpoints, "POST /api/ship/current/stop">) => ({
      call: (): Promise<ILogResponse> => {
        assertTarget(this.client, "POST /api/ship/current/stop", currentLogApiEndpoints["POST /api/ship/current/stop"].targets);
        return this.client.call<ILogResponse>("POST /api/ship/current/stop", a);
      },
      url: (): string => this.client.url("POST /api/ship/current/stop", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
